"use client";
/**
 * `?subscribe=<tier>` → open the shared <SubscribeWidget> on that plan. The landing's plans table
 * sends a visitor to sign in with this return; once the app renders (any page), the widget opens
 * with the chosen plan highlighted and the parameter is dropped from the URL.
 */
import { useEffect } from "react";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { openSubscribe, isSubscribeWidgetMounted } from "@owlcat/app-shell";

const TIERS = new Set(["basic", "pro", "family"]);

export function SubscribeDeepLink() {
  const params = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const tier = params.get("subscribe");
  useEffect(() => {
    if (!tier || !TIERS.has(tier)) return;
    let tries = 0;
    const t = setInterval(() => {
      tries++;
      if (isSubscribeWidgetMounted() || tries > 20) {
        clearInterval(t);
        if (isSubscribeWidgetMounted()) openSubscribe("habits", tier);
        const next = new URLSearchParams(params.toString()); next.delete("subscribe");
        router.replace(next.size ? `${pathname}?${next}` : pathname, { scroll: false });
      }
    }, 100);
    return () => clearInterval(t);
  }, [tier]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
